import React from 'react';

import ToastCross from '../../../assets/toast-cross.svg';

export const ToastCrossIcon: React.FC = () => (
  <img src={ToastCross} alt="cross icon" />
);
